import Figure from 'react-bootstrap/Figure';

export default function guideFigure({img, caption}) {
  return (
    <Figure className='m-5 d-flex flex-row'>
      <Figure.Image
        width={171}
        height={180}
        alt="171x180"
        src={img}
      />
      <Figure.Caption className='mx-3'>
        <h3>{caption}</h3>
      </Figure.Caption>
    </Figure>
  );
}